export class RemoveTextLimitMarkerFormatter {
  in(value: string, specialCharacter: string) {
    const indexOfSpecialCharacter = value.indexOf(specialCharacter);
    return value.slice(0, indexOfSpecialCharacter).trimRight();
  }
  out(value: string) {
    return value.trimRight();
  }
}
